var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPushNotificationsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.589,
    height: 13.589,
    viewBox: "0 0 13.589 13.589",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30391",
    "data-name": "Group 30391",
    transform: "translate(0.512 0.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11966",
    "data-name": "Path 11966",
    d: "M15.142,4.776,5.977,7.231a1.7,1.7,0,0,0-.762,2.843l5.325,1.209,1.384,5.5a1.7,1.7,0,0,0,2.843-.762l2.456-9.164A1.7,1.7,0,0,0,15.142,4.776Z",
    transform: "translate(-4.717 -4.716)",
    fill: "rgba(0,0,0,0)",
    stroke: "#fc8a06",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_72",
    "data-name": "Line 72",
    y1: 6.807,
    x2: 6.807,
    transform: "translate(5.38 0.379)",
    fill: "none",
    stroke: "#fc8a06",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushNotificationsIcon);
export default __webpack_public_path__ + "static/media/pushNotificationsIcon.0ccba776c90a975231f7909fd92b0799.svg";
export { ForwardRef as ReactComponent };